import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-swiper-reading-resources',
    templateUrl: './swiper-reading-resources.component.html',
    styleUrls: ['./swiper-reading-resources.component.scss']
})
export class SwiperReadingResourcesComponent implements OnInit {

    posts: any = [];
    loadedPosts: boolean = false;

    // A swiper config which is responsive and doesn't show partial slides

    public responsiveNoOverflowConfig: any = {
        slidesPerView: 1,
        spaceBetween: 15,
        freeMode: true,
        watchOverflow: true, // Automatically hides pagination when not needed
        pagination: { clickable: true },
        breakpoints: {
            576: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3
            },
        }
    };

    constructor(private api: ApiService, private cd: ChangeDetectorRef) { }

    ngOnInit(): void {

        this.fetchPosts();

    }

    /**
     * Fetches notice board posts
     */
    async fetchPosts() {

        await this.api.fetch_posts()
            .subscribe(res => {
                this.posts = res.data.items;
                this.posts = this.posts.slice(0, 3);

                this.posts.forEach(element => {
                    let tags = [];

                    element.tagged.forEach(subelement => {
                        tags.push(subelement.tag_name);
                    });

                    if (tags.length > 0) {
                        element.tag = tags[0]
                    } else {
                        element.tag = '';
                    }
                });

                this.loadedPosts = true;
                this.cd.detectChanges();
            }, (err) => {

            });

    }

    /**
     * When 'Reading and resources' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onResourcesSwiper(swiper) {

        setTimeout(() => {
            //  swiper.update();
        }, 1500);

    }

}
